<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
export default {
  computed: {
    ...mapGetters(['getToast'])
  },
  methods: {
    checkURL() {
      if(this.$route.query.course) {
        // Check if User Logged In
        if(this.getLoggedUser() && this.getToken()) {
          if(this.getLoggedUser().type === 'member') {
            this.$router.push('/booking', {query: {type: 'member', course: this.$route.query}})
          }
          if(this.getLoggedUser().type === 'corporate') {
            this.$router.push('/booking', {query: {type: 'corporate', course: this.$route.query}})
          }
        } else {
          const course = {
            course: this.$route.query.course
          }
          // Save Course ID in Local Storage for future Use
          localStorage.setItem('course', JSON.stringify(course))
        }
      }
    }
  },
  created() {
    this.checkURL()
    axios.interceptors.response.use(
      response => {
        console.log(response)
        if (response.status === 200 || response.status === 201) {
          return Promise.resolve(response);
        } else {
          return Promise.reject(response);
        }
      },
      error => {
        if(error) {
          if (error.status == 401) {
            this.$router.push({
              path: "/"
            });
            return Promise.reject(error);
          }
        }
      }
    );
  },
  watch: {
    getToast(val) {
      if(val.message) {
        this.toast(val)
      }
    },
  }
}
</script>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden !important;
  background: rgba(232, 248, 255, 0.603);
  min-height: 100vh;
}

.text-green {
  color:#008001 !important; 
}

.text-lightgreen {
  color:#7ed321 !important;
}

.btn-success {
  color:#008001 !important; 
  color: white !important;
  outline: none !important;
  border: none !important;
}

.text-grey {
  color: grey;
}

.btn-success:focus, input:focus, select:focus {
  border-color: #ddd !important;
  box-shadow: none !important;
}

.link:hover {
  cursor: pointer;
}

.roundeds{
 border-radius: 1.25rem !important
}

.fc-time-grid-event{
  background:white !important;
  padding-left: 10px !important;
  border-color:white !important;
  border-left: 2px solid #117a8b !important;
  
}
.fc-day-grid-event{
  background:yellow !important;
  padding-left: 10px !important;
  border-color:white !important;
  border-left: 2px solid #117a8b !important;
  
}
.fc-event{

}
.fc-event-time{
  overflow: visible !important;
}
.fc-selected-event-color{
  background: #17a2b8 !important;
  color:white !important;
}
</style>
